<div class="form-item"  [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
 
  <!-- [ngClass]="{'invalid-field': !valid}" -->
  <div class="form-content" [ngClass]="{'invalid-field': (!valid && fieldSubmission.field.mandatory)}">
    <div>
      <core-helpers-forms-wysiwyg-extended
        [placeholder]="placeholder"
        [content]="value"
        [emojis]="true"
        (textChange)="onTextEditorChange($event)"
      ></core-helpers-forms-wysiwyg-extended>
    </div>
  </div>
  
</div>